import React from "react";
import Header from "../../layout/Header";
import LeftBar from "../leftBar/LeftBar";
import PlaceBar from "./sections/PlaceBar";
import WayBillModal from "../../dashboard/WayBillModal";

export default function PlaceOrder() {

  return (
    <section className="font-soehne">
      <Header />
      <section className="lg:py-20 py-12 xl:w-5/6 w-11/12 mx-auto grid lg:grid-cols-12">
        <LeftBar />
        <PlaceBar />
        {/* <WayBillModal /> */}
      </section>
    </section>
  );
}
